import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d='M8 14.667A6.667 6.667 0 118 1.333a6.667 6.667 0 010 13.334zm0-1.334A5.334 5.334 0 108 2.666a5.334 5.334 0 000 10.667zm-3.334-6h6.667v1.334H4.666V7.333z'
      ></path>
    </svg>
  )
}

export default Icon
